import React, { useEffect, useState, useRef } from "react";
import { Table, Input, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCFDetails } from "../../../auth/services/privateapicalling";

const { Option } = Select;

const SponsorRegsitrationMenu: React.FC = () => {
  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [appStatussssLvl, setAppStatussssLvl] = useState("")

  // Status counts
  const [statusCounts, setStatusCounts] = useState({
    total: 0,
    pending: 0,
    approved: 0,
    queried: 0,
  });

  // // Set default filter based on role
  // useEffect(() => {
  //   if (roleIdentifier === "MBA") {
  //     setSelectedStatus("pendingAtMBA");
  //   } else if (roleIdentifier === "MBMD") {
  //     setSelectedStatus("pendingAtMBMD");
  //   } else if (roleIdentifier === "SPO") {
  //     setSelectedStatus("all");
  //   } else {
  //     setSelectedStatus("");
  //   }
  // }, [roleIdentifier]);

  // Fetch data from API
  useEffect(() => {
    if (selectedStatus) {
      setCurrentPage(1); // Reset to first page when status changes
      fetchApplications(selectedStatus, 0, pageSize);
    }
  }, [selectedStatus]);

  const fetchApplications = async (
    appStatusLevel: string,
    page: number = 0,
    limit: number = 10,
    search: string = ""
  ) => {
    setLoading(true);
    try {
      // Pass pagination and search parameters to your API
      const response = await getCFDetails(appStatusLevel, token);

      if (response.success) {
        const formattedData = response.data.map((item: any, index: number) => {
          const rawDate = item.createdAt || "";
          let formattedDate = "N/A";
          if (rawDate) {
            const d = new Date(rawDate);
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            formattedDate = `${day}-${month}-${year}`;
          }
          return {
            key: item.applicationId || index,
            SpID: item.applicationId,
            date: formattedDate,
            status: item.status,
            appStatusLevel: item.appStatusLevel,
            action: item.action,
          };
        });
        setAppStatussssLvl(appStatusLevel)
        setData(formattedData);
        setFilteredData(formattedData);
        setTotalCount(response.totalCount || 0);
        calculateStatusCounts(formattedData);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  };

  const calculateStatusCounts = (applications: any[]) => {
    const counts = {
      total: applications.length,
      pending: applications.filter((app) => app.status === "pending").length,
      approved: applications.filter((app) => app.status === "approved").length,
      queried: applications.filter((app) => app.status === "queried").length,
    };
    setStatusCounts(counts);
  };

  const handleRedirect = () =>{
    navigate("/sponsor-registration")
  }

//   const handleRedirect = (applicationId: string) => {
//     navigate(`/marketing-board-registration`, {
//       state: {
//         applicationId: applicationId,
//       },
//     });
//   };
  const handleSPORedirect = (applicationId: string) => {
    navigate(`/registration-status`, {
      state: {
        applicationId: applicationId,
      },
    });
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    setCurrentPage(1); // Reset to first page on search
    fetchApplications(selectedStatus, 0, pageSize, value);
  };

  // const handleStatusFilterChange = (value: string) => {
  //   setSelectedStatus(value);
  // };

  const handlePaginationChange = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    // Convert 1-based page (from Ant Design) to 0-based page for API
    fetchApplications(selectedStatus, page - 1, pageSize, searchText);
  };

const columns = [
    {
      title: (
        <div style={{ whiteSpace: "normal" }}>
          Application Id
        </div>
      ),
      dataIndex: "SpID",
      width: "25%",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: "normal" }}>
          Applied Date
        </div>
      ),
      dataIndex: "date",
      width: "25%",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: (
        <div style={{ whiteSpace: "normal" }}>
          Status
        </div>
      ),
      dataIndex: "status",
      width: "25%",
      render: (text: string) => (
        <span
          className={` ${
            text === "pending"
              ? "text-warning"
              : text === "approved"
              ? "text-success"
              : text === "permanentReject"
              ? "text-danger"
              : ""
          }`}
        >
          {text==="reject"?"Query Raised" : text==="permanentReject"?"Permanent Reject" : text.charAt(0).toUpperCase() + text.slice(1)}
          {/* {text} */}
        </span>
      ),
    },
    {
      title: "Action (Review)",
      dataIndex: "action",
      width: "25%",
      render: (action: boolean, record: any) => {
        const status = record.status;
        
        return (
          <div className="d-flex gap-2">
            <button
              className="btn btn-outline-info fs-18 p-1 px-2"
              onClick={() => handleSPORedirect(record.SpID)}
            >
              View Application
            </button>
          </div>
        );
      }
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div>
          <div className="content">
            {/* <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Registered Application Review</h2>
              </div>
            </div> */}

            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2 d-flex justify-content-between w-100">
                <div>
                  <h2 className="mb-1">Registration</h2>
                  <p style={{ fontSize: "1.25rem" }}>
                    Go to the Registration Page
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <button className="btn btn-info" onClick={handleRedirect}>
                    <i className="feather feather-plus-circle me-2"></i>
                    New Registration
                  </button>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body p-0">
                <div className="table-top-data">
                  <div className="row p-3">
                    <div className="col-sm-6">
                      {/* <Select
                        placeholder="Filter by Status Level"
                        style={{ width: 300 }}
                        value={selectedStatus}
                        onChange={handleStatusFilterChange}
                      >
                        <Option value="all">All Applications</Option>
                        <Option value="pendingAtSponsor">
                          Pending at Sponsor
                        </Option>
                        <Option value="pendingAtMBA">
                          Marketing Board Administrator
                        </Option>
                        <Option value="pendingAtMBMD">
                          Marketing Board Managing Director
                        </Option>
                      </Select> */}
                    </div>
                    <div className="col-sm-6 d-flex justify-content-end">
                      <Input
                        placeholder="Search Application Id..."
                        style={{ width: 250 }}
                        allowClear
                        value={searchText}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <Table
                  className="table datanew dataTable no-footer"
                  columns={columns}
                  rowHoverable={false}
                  rowKey={"SpID"}
                  dataSource={filteredData}
                  loading={loading}
                  pagination={{
                    locale: { items_per_page: "" },
                    nextIcon: <i className="ti ti-chevron-right" />,
                    prevIcon: <i className="ti ti-chevron-left" />,
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalCount,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePaginationChange,
                    onShowSizeChange: handlePaginationChange,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SponsorRegsitrationMenu;